import HeroSmall from "../../components/HeroSmall/HeroSmall";
import "./AboutStaff.scss";
import joshHeadshot from "../../assets/images/Headshot.jpg";

export default function AboutStaff() {
  return (
    <div className="about-staff">
      <HeroSmall extraClass="heroSmall__about" content="our staff" />
      <section className="bio-card">
        <img
          src={joshHeadshot}
          alt="Pastor Josh Headshot"
          className="bio-card__img"
        />
        <div className="bio-card__bio">
          <p className="bio-card__header">Meet our pastor</p>
          <h3 className="bio-card__name">Josh Hunter</h3>
          <section className="bio-card__bio">
            <p className="bio-card__text">
              Joshua Hunter has served as the pastor of the First Free Will
              Baptist Church of Waverly since June 2023. He grew up around the
              country but settled in Tennessee when he began attending Welch
              College. Josh holds a B.S. in Theology and an M.A. in Theology and
              Ministry from Welch College, an M.Div. from Welch Divinity School,
              and a Th.M. in Ancient Languages and Cultures from Gordon-Conwell
              Theological Seminary. He is currently working on a Graduate
              Certificate in Semitic Languages from Denver Seminary.
            </p>
            <p className="bio-card__text">
              Apart from his schooling, Josh enjoys spending time reading,
              writing, and in the Waverly community. He is married to his
              wonderful wife, Michaela, and you may often see him with his dog,
              Cassie, or his cat, Ronald. He is the chaplain of the Humphreys
              County Historical Society and loves to visit local restaurants. He
              loves serving the church and hopes to get to meet you should you
              visit.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
